// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@steiner/App/SharedStyles/CartLineSharedStyles";
import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { openBidsDetailsProductListStyles } from "@steiner/App/Widgets/OpenBidsDetails/OpenBidsDetailsProductList";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

openBidsDetailsProductListStyles.mainWrapper = {
    css: css`
        margin-top: 20px;
    `,
};
openBidsDetailsProductListStyles.cartLineContainerStyles = {
    container: {
        css: css`
            margin-bottom: 20px;
        `,
    },
};

openBidsDetailsProductListStyles.pricingContainer = {
    css: css`
        display: flex;
        gap: 4px;
        align-items: flex-end;
    `,
};
openBidsDetailsProductListStyles.priceStyles = openBidsDetailsProductListStyles.extPriceStyles = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

openBidsDetailsProductListStyles.addToListLink = { ...cartLineSharedStyles.cartLineNotes?.addToProjectsLink };
openBidsDetailsProductListStyles.uomValue = mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
    css: css`
        font-weight: ${fontConfig.weight.semiBold};
    `,
});
